import { showDeleteConfirmation } from "components/ApiKeys/DeleteConfirmation";
import { showResetConfirmation } from "components/ApiKeys/ResetConfirmation";
import DropdownMenuEllipsis from "ds/components/DropdownMenu/Ellipsis";
import DropdownMenuItem from "ds/components/DropdownMenu/Item";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import { ApiKeyType } from "types/generated";

import { showPersonalSettingsApiKeysDetailsDrawer } from "../../DetailsDrawer";
import { showPersonalSettingsApiKeysEditDrawer } from "../../EditDrawer";
import { GET_PERSONAL_API_KEYS, PersonalApiKey } from "../../gql";

const REFETCH_QUERIES = [GET_PERSONAL_API_KEYS];

const PersonalApiKeysTableDropdownCell = ({
  item: apiKey,
  ...cellProps
}: TableSimpleCellProps<PersonalApiKey>) => {
  const onEditDetailsClick = () => {
    showPersonalSettingsApiKeysEditDrawer({
      apiKey,
      refetchQueries: REFETCH_QUERIES,
    });
  };

  const onDetailsClick = () => {
    showPersonalSettingsApiKeysDetailsDrawer({
      apiKey,
    });
  };

  const onResetClick = () => {
    showResetConfirmation({ name: apiKey.name, id: apiKey.id });
  };

  const onDeleteClick = () => {
    showDeleteConfirmation({
      name: apiKey.name,
      id: apiKey.id,
      refetchQueriesOnDelete: REFETCH_QUERIES,
    });
  };

  return (
    <TableSimpleCell {...cellProps}>
      <DropdownMenuEllipsis tooltip="API key actions">
        <DropdownMenuItem onAction={onEditDetailsClick}>Edit details</DropdownMenuItem>
        <DropdownMenuItem onAction={onDetailsClick}>See details</DropdownMenuItem>
        {apiKey.type === ApiKeyType.Secret && (
          <DropdownMenuItem onAction={onResetClick}>Reset</DropdownMenuItem>
        )}
        <DropdownMenuItem onAction={onDeleteClick} danger>
          Delete
        </DropdownMenuItem>
      </DropdownMenuEllipsis>
    </TableSimpleCell>
  );
};

export default PersonalApiKeysTableDropdownCell;
